import { last } from 'lodash';
import {
  ConsumerExploreDishFirstQuery,
  DishFirstContentItem,
  ExploreSegmentShef,
} from 'src/gqlReactTypings.generated.d';

export const mergePaginatedSegments = (
  queryResults: ConsumerExploreDishFirstQuery | undefined
): ConsumerExploreDishFirstQuery | undefined => {
  if (queryResults?.exploreFoodItems === undefined) {
    return undefined;
  }

  const querySegments = queryResults.exploreFoodItems;
  const segmentsMerged = querySegments.reduce<ConsumerExploreDishFirstQuery['exploreFoodItems']>(
    (mergedSegments, currentSegment) => {
      const previousSegment = last(mergedSegments);
      if (previousSegment?.id !== currentSegment.id) {
        // No merging necessary
        return [...mergedSegments, currentSegment];
      }

      // Merge these two segments' contents
      const newSegmentContentItems = [
        ...(previousSegment.content.items as DishFirstContentItem[]),
        ...(currentSegment.content.items as DishFirstContentItem[]),
      ];
      const shefIds = newSegmentContentItems.reduce((ids, item) => {
        if (item.__typename === 'ExploreSegmentShef') {
          ids[item.shef.id] = item;
        } else if (item.__typename === 'FoodItem') {
          ids[item.id] = item;
        } else if (item.__typename === 'CuisineCategory') {
          ids[item.id] = item;
        } else if (item.__typename === 'PublicShef') {
          ids[item.id] = item;
        } else if ('shef' in item && item.shef?.id) {
          ids[item.shef.id] = item as ExploreSegmentShef;
        }
        return ids;
      }, {} as Record<string, DishFirstContentItem>);
      const shefItems = Object.values(shefIds);
      const newSegmentContent = {
        ...previousSegment.content,
        items: shefItems as typeof previousSegment.content.items,
      };
      return [
        // Exclude the last item in the previous list, since
        // we want to replace it with the merged version:
        ...mergedSegments.slice(0, mergedSegments.length - 1),
        {
          ...currentSegment,
          content: newSegmentContent,
        },
      ];
    },
    [] as ConsumerExploreDishFirstQuery['exploreFoodItems']
  );

  return {
    ...queryResults,
    exploreFoodItems: segmentsMerged,
  };
};
